import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Form, FormField, Label, LabeledControl, Radio, spaceMixin } from '@zillow/constellation';

const StyledForm = styled(Form)`
  && {
    margin-bottom: ${spaceMixin('md')};
  }
`;

const StyledLabelControl = styled(LabeledControl)`
  &&& {
    margin-bottom: 0;
  }
`;

export default function BodySectionForm({ form, setFormAnswer }) {
  return (
    <StyledForm>
      <FormField>
        {form.options.map((option) => {
          if (option.type === 'radio') {
            return (
              <StyledLabelControl
                key={option.id}
                label={<Label htmlFor={option.id}>{option.label}</Label>}
                control={
                  <Radio name={`${form.id}`} id={option.id} onChange={() => setFormAnswer(form.id, option.id)} />
                }
              />
            );
          }

          return null;
        })}
      </FormField>
    </StyledForm>
  );
}

BodySectionForm.propTypes = {
  form: PropTypes.shape({
    id: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        label: PropTypes.string,
      }),
    ).isRequired,
  }).isRequired,
  setFormAnswer: PropTypes.func.isRequired,
};
